export {
  TableOfContents,
  type TableOfContentsProps,
  type TocItem,
} from './TableOfContents';
export {
  TableOfContentsItem,
  type TableOfContentsItemProps,
} from './TableOfContents';
